// extracted by mini-css-extract-plugin
export default {"a0":"zVpHkXJNFUJvIRE6Z3Qp","a1":"A2iDIT8CFjQUvYeP4Cc_","cls1":"eT2daZftVf0SUQbZwf1O","cls2":"flkicCAo3XfF_fArO0s2 eT2daZftVf0SUQbZwf1O"};